import { z } from 'zod';

const FenceTypeDef = [
    'Barbed Wire',
    'Deer Fence',
    'Electric',
    'Field Fence',
    'Horse Fence',
    'Joining Wire',
    'Metal T-post',
    'Plain Wire',
    'Post and Rail',
    'Predator Fence',
    'Straining Wire',
    'Synthetic',
    'Welded wire',
    'Wildlife Fence',
    'Wooden Fence',
    'Woven',
] as const;

export const allFenceTypes = [...FenceTypeDef];

export type FenceType = (typeof FenceTypeDef)[number];

export const fenceTypeSchema = z.enum(FenceTypeDef);
